import {
  useInitializeBatchForDocument,
  useInitializeContactChanges,
  useInitializeDocument,
  useInitializeDocumentBatchUsers,
  useInitializeDocumentFileInfo,
  useInitializeDocumentSummary,
  useInitializeDocumentTypes,
  useInitializeDocumentUsers,
} from './hooks'

interface DocumentInitializationProps {
  documentId: string
}

export const DocumentInitialization: React.FC<DocumentInitializationProps> = ({ documentId }) => {
  useInitializeDocumentTypes()
  useInitializeDocument(documentId)
  useInitializeDocumentUsers()
  useInitializeDocumentSummary(documentId)
  useInitializeContactChanges(documentId)
  useInitializeDocumentFileInfo()
  useInitializeBatchForDocument()
  useInitializeDocumentBatchUsers()

  return null
}
